// extracted by mini-css-extract-plugin
export default {"tabDashboardOverview":"TabDashboardOverview_tabDashboardOverview__FMNRw","rangeSelect":"TabDashboardOverview_rangeSelect__i+rRP","card":"TabDashboardOverview_card__9QE0Y"};